"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefineModal = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const horizontal_picker_1 = require("./horizontal-picker");
const refine_modal_style_1 = require("./refine-modal.style");
const localization_1 = require("../../../localization");
const RefineModal = ({ columns, defaultColumns, isOpen, setOpen, activeColumns, setActiveColumns, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const initialColumns = (0, react_1.useRef)(null);
    const [isFieldsOpen, setFieldsOpen] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            initialColumns.current = activeColumns;
        }
    }, [isOpen]);
    const handleApply = () => {
        setOpen(false);
    };
    const handleReset = () => {
        setActiveColumns(defaultColumns);
    };
    const handleClose = () => {
        setActiveColumns(initialColumns.current);
        setOpen(false);
    };
    const handleDataChange = (selectedItems) => {
        setActiveColumns(selectedItems);
    };
    return (react_1.default.createElement(ui_components_1.Modal, { open: isOpen, title: t({ key: 'REFINE' }), handleClose: handleClose, primaryButtonLabel: t({ key: 'DONE' }), primaryButtonDisabled: false, handlePrimaryClick: handleApply }, react_1.default.createElement(refine_modal_style_1.StyledRefineModalRoot, null, react_1.default.createElement(refine_modal_style_1.StyledRefineModalBody, null, react_1.default.createElement("div", { className: "RefineModal-Accordion-Wrap" }, react_1.default.createElement(ui_components_1.Accordion, { isOpened: isFieldsOpen, onToggle: setFieldsOpen, heading: t({ key: 'FIELDS' }) }, react_1.default.createElement(horizontal_picker_1.HorizontalPicker, { resetButtonTitle: t({ key: 'RESET' }), activeTitle: t({ key: 'ACTIVE' }), searchPlaceHolder: `${t({ key: 'SEARCH' })}...`, height: 250, data: columns, selectedIds: activeColumns, onDataChange: handleDataChange, onReset: handleReset })))))));
};
exports.RefineModal = RefineModal;
exports.default = exports.RefineModal;
